import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Error } from '@zhike/ti-component';

// 错误
class ErrorContainer extends Component {
  render() {
    return (
      <Error {...this.props} />
    );
  }
}

const mapStateToProps = () => ({});

export default connect(mapStateToProps, {})(ErrorContainer);



// WEBPACK FOOTER //
// ./src/containers/error.js